import React, { Fragment, useEffect, useState } from 'react'
import { sendMessage } from 'services/messenger'
import { decodeUrl } from 'utils/decode'
import { transformOrder } from 'utils/helpers'
import { Privacy } from '../Privacy/Privacy'
import {
	ContainerPlan,
	PlanList,
	Title,
	Validity,
	AmountContainer,
	Amount,
	TotalContainer,
	Total,
	Modifier,
} from './PayPalCheckoutDetails.styles'

type CheckoutDetailsProps = {
	onAccept?: (checked: boolean) => void
	paypalOrder?: any
}
export const PayPalCheckoutDetails = ({
	onAccept,
	paypalOrder,
}: CheckoutDetailsProps) => {
	const [checkoutInfo, setCheckoutInfo] = useState<any>({
		currency: '',
		discountPercentage: 0,
		employeeId: '',
		items: [],
		validity: '',
		value: '',
		valueWithDiscount: 0,
	})

	const handleBack = () => {
		sendMessage({
			status: 'modify',
			data: {},
		})
	}

	const getProps = async () => {
		const orderDecoded = decodeUrl(window.location.search)
		const { order } =
			orderDecoded?.order?.type === 'PAYMENT'
				? await transformOrder(orderDecoded)
				: orderDecoded
		setCheckoutInfo({
			...order,
		})
	}

	const getDescription = () => {
		const { items } = checkoutInfo
		const descriptions = items.map((item: any) => {
			if (item.type === 'dependent') {
				return item?.beneficiaryData?.firstName
			}
			return item.description
		})
		return [...new Set(descriptions)]
	}

	useEffect(() => {
		getProps()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<ContainerPlan>
			<PlanList>
				{getDescription().map((item: any, index: number) => (
					<Fragment key={index}>
						<>
							{item && (
								<li>
									<Title>{item}</Title>
								</li>
							)}
						</>
					</Fragment>
				))}
			</PlanList>
			<Validity>
				Vigencia hasta el<strong>&nbsp;{checkoutInfo.validity}</strong>
			</Validity>
			<AmountContainer>
				<TotalContainer>
					<Amount>Total a pagar</Amount>
					<Total>
						$ {paypalOrder.value.toFixed(2)} {paypalOrder.currency}
					</Total>
				</TotalContainer>
				<Modifier onClick={handleBack}>Modificar</Modifier>
			</AmountContainer>
			{onAccept && <Privacy onAccept={onAccept} />}
		</ContainerPlan>
	)
}
